import {api} from '@/http'

// 职位订阅设置获取
const getTakeConfig = (callback, back) => {
  api('/api/subscription/config', 'get', '', callback, back)
}

// 职位订阅设置获取
const setTakeConfig = (data, callback, back) => {
  api('/api/subscription/config', 'post', data, callback, back)
}

export default {
  getTakeConfig,
  setTakeConfig
}



// WEBPACK FOOTER //
// ./src/api/take/index.js